import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';


import Table from 'react-bootstrap/Table';



class TablaProm2005 extends React.Component {





render(){


  return(
    <Row className="justify-content-md-center">
    <Col lg={6} xl={6}  >
    <Table variant="dark" striped bordered hover size="sm">
  <thead>
    <tr style={{textAlign: 'center' }}>
	<th > </th>
	<th>Pos</th>
      <th>Equipo</th>
      <th>Pts 03</th>
      <th>Pon 03</th>
      <th>Pts 04</th>
      <th>Pon 04</th>
      <th>Pts 05</th>
      <th>Pon 05</th>
	<th>Pon Total</th>
    </tr>
  </thead>
  <tbody>
{this.props.teams.map((team, i) => {

	return(<tr style={{textAlign: 'center' }}>
		 {team.color !== 0 && <td bgcolor={team.color}></td>}
		 {team.color === 0 && <td></td>}
  		 <td >{i + 1}</td>
                 <td ><Image   data-tip data-for={team.shortname+'-escudo'} className="list-escudo" src={'/images/escudos/'+team.shortname+'.png'}/>
                  {" " + team.rivalName}
                 </td>
                 <td >{team.pts03}</td>
                 <td >{team.pon03}</td>
                 <td >{team.pts04}</td>
                 <td >{team.pon04}</td>
                 <td >{team.pts05}</td>
                 <td >{team.pon05}</td>
                 <td >{team.pon}</td>
              </tr>);
	})}

</tbody>
</Table>
</Col>
</Row>
  )
}
}
export default TablaProm2005;
